import classes from './css/barcodesList.module.css';

import { useState } from 'react';
import useAlert from 'hooks/useAlert';
import Select from 'ui/Select';

const BarcodesList = ({
  id,
  handleInputChange,
  item,
  handleItemRemove,
  availableBarcodes,
  isLastItem,
  handleAddItem,
  multiList = true,
  disabled,
}) => {
  const { showAlert } = useAlert();
  const [hovered, setHovered] = useState(false);

  const sureDeleteBarcodeAlert = (callback) => {
    showAlert(`Вы уверены что хотите удалить данный штрихкод?`, 'sure', callback);
  };

  return (
    <div
      className={classes.containerParent}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className={classes.container}>
        <div className={classes.barcodeContainer}>
          <Select
            options={availableBarcodes}
            value={item?.id ?? 0}
            onChange={(val) => handleInputChange(id, val, 'id')}
            disabled={disabled}
            clearable={false}
            hideErrorBlock={true}
          />
        </div>
        <div className={`${classes.barcodeContainer} ${classes.barcodeContainerWithInput}`}>
          <input
            className={classes.inputBarcode}
            type="text"
            name={id}
            placeholder="Введите штрихкод"
            onChange={(event) => handleInputChange(id, event.target.value, 'value')}
            value={item?.value ?? ''}
            disabled={disabled}
          />
        </div>
      </div>
      {multiList && (
        <div className={`${classes.buttons} `}>
          {hovered && (
            <>
              {id > 0 && (
                <div
                  className={classes.buttonClear}
                  onClick={() => sureDeleteBarcodeAlert(() => handleItemRemove(id))}
                >
                  <div className={'close_icon'}></div>
                </div>
              )}
              {isLastItem && (
                <div className={classes.buttonAdd} onClick={() => handleAddItem()}>
                  <div className={'plus_icon'}></div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default BarcodesList;
